export class DtoEstado {
    ID_Estado: number = 1;
    Nombre: string = 'ACTIVO';
}